import type { ReactNode } from 'react';

import { useHasAnyPermission, useHasPermission } from '../features/auth/usePermission';

type PermissionGateProps = {
  readonly permission: string | readonly string[];
  readonly fallback?: ReactNode;
  readonly children: ReactNode;
};

export function PermissionGate({ permission, fallback = null, children }: PermissionGateProps) {
  const hasPermission = Array.isArray(permission)
    ? useHasAnyPermission(permission as readonly string[])
    : useHasPermission(permission as string);

  return hasPermission ? <>{children}</> : <>{fallback}</>;
}
